// elements/smart-phone-42.js
import { LitElement } from "lit";
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n as i18n2 } from "@lingui/core";

// src/raw/smart-phone/locales/nb/messages.mjs
var messages = JSON.parse('{"icon.title.smartphone":"Smarttelefon"}');

// src/raw/smart-phone/locales/en/messages.mjs
var messages2 = JSON.parse('{"icon.title.smartphone":"Smartphone"}');

// src/raw/smart-phone/locales/fi/messages.mjs
var messages3 = JSON.parse('{"icon.title.smartphone":"\xC4lypuhelin"}');

// src/utils/i18n.ts
import { i18n } from "@lingui/core";
var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale();
  const messages4 = getMessages(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages4);
  i18n.activate(locale);
};

// elements/smart-phone-42.js
activateI18n(messages2, messages, messages3);
var IconSmartPhone42 = class extends LitElement {
  render() {
    const title = i18n2.t({ message: `Smartphone`, id: "icon.title.smartphone", comment: "Title for smartphone icon" });
    return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28" part="w-icon-smart-phone-42-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M25.667 1h-8.334C15.493 1 14 2.552 14 4.467v19.066C14 25.448 15.492 27 17.333 27h8.334C27.507 27 29 25.448 29 23.533V4.467C29 2.552 27.508 1 25.667 1"></path><path fill="currentColor" d="M19 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0 3.375a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0 3.375a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0 10.125a1 1 0 1 0-2 0 1 1 0 0 0 2 0M22.5 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0 3.375a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0 3.375a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0 10.125a1 1 0 1 0-2 0 1 1 0 0 0 2 0M26 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0 3.375a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0 13.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0"></path></svg>`;
  }
};
if (!customElements.get("w-icon-smart-phone-42")) {
  customElements.define("w-icon-smart-phone-42", IconSmartPhone42);
}
export {
  IconSmartPhone42
};
//# sourceMappingURL=smart-phone-42.js.map
